import React, { ReactNode, useState } from "react"
import { CgClose } from "react-icons/cg"
import styled from "styled-components"
import UpdateMarketInsight from "./updateMarketInsight"
import ConfirmUpdateInsight from "./confirmUpdateMarketInsight"

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  background-color: #20200020;
  z-index: 100;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`

const ModalBox = styled.div`
  position: relative;
  padding: 50px;
  max-width: 30%;
  background-color: white;
  border-radius: 5px;
  border: 1px solid #d4d4d4;
  box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.2);
`

const CloseButton = styled.button`
  position: absolute;
  right: 0;
  top: 0;
  appearance: none;
  background-color: transparent;
  border: 0;
  padding: 15px;
`

export enum UpdateInsightData {
  Form,
  Confirm,
  Error,
}

const ModalCard = ({
  onClose,
  children,
}: {
  onClose: () => void
  children: ReactNode
}) => {
  return (
    <ModalBox
      data-testid="modalCard"
      onClick={(ev) => {
        ev.stopPropagation()
      }}
    >
      <CloseButton onClick={() => onClose()}>
        <CgClose size={24} />
      </CloseButton>
      {children}
    </ModalBox>
  )
}

const UpdateInsightModal = ({
  marketId,
  title,
  subtitle,
  description,
  onClose,
  parent2Callback,
}: {
  marketId: string
  title: string
  subtitle: string
  description: string
  onClose: () => void
  parent2Callback: () => void
}) => {
  const [step, setStep] = useState<UpdateInsightData>(UpdateInsightData.Form)
  const [data, setData] = useState<{
    marketId: string
    titleEdit: string
    subtitleEdit: string
    descriptionEdit: string
    error: string
  }>({
    marketId,
    titleEdit: "",
    subtitleEdit: "",
    descriptionEdit: "",
    error: "",
  })

  return (
    <Overlay onClick={() => setStep(UpdateInsightData.Form)}>
      <ModalCard onClose={onClose}>
        {step === UpdateInsightData.Form && (
          <UpdateMarketInsight
            marketId={marketId}
            title={title}
            subtitle={subtitle}
            description={description}
            onSubmit={(titleEdit, subtitleEdit, descriptionEdit) => {
              setData((prev) => ({
                ...prev,
                titleEdit,
                subtitleEdit,
                descriptionEdit,
              }))
              setStep(UpdateInsightData.Confirm)
            }}
          />
        )}
        {step === UpdateInsightData.Confirm && (
          <ConfirmUpdateInsight
            marketId={data.marketId}
            title={data.titleEdit}
            subtitle={data.subtitleEdit}
            description={data.descriptionEdit}
            onCancel={() => onClose()}
            onError={(error: any) => {
              setData((prev) => ({ ...prev, error }))
              setStep(UpdateInsightData.Error)
            }}
            onSuccess={() => onClose()}
            parentCallback={() => parent2Callback()}
          />
        )}
        {step === UpdateInsightData.Error && `API Error: ${data.error}`}
      </ModalCard>
    </Overlay>
  )
}

export default UpdateInsightModal
